<template>
    <div class="badge badge-pill badge-light" v-if="hasCartItems" v-html="getCartItemsNumber"></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'offerteBadge',
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            getCartInfo: 'getCartInfo'
        }),
        cartInfo() {
            return this.getCartInfo;
        },
        hasCartItems() {
            if (this.cartInfo.items.length > 0) {
                return true;
            }
            return false;
        },
        getCartItemsNumber() {
            let count = 0;
            const items = this.cartInfo.items;
            for (let i = 0; i < items.length; i++) {
                count += items[i].qty;
            }
            return count;
        }
    }
};
</script>
